import { render } from "./trades-subpage.vue?vue&type=template&id=58280ad9"
import script from "./trades-subpage.vue?vue&type=script&lang=js"
export * from "./trades-subpage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__